import React from 'react';
import project10 from './../../image/project10.png'

const SoloTraveller = () => {
    return (
        <div>
            <div className=' my-24 '>

                <div class=" container mx-auto grid grid-cols-1  gap-4">
                    <div class="card w-100 bg-base-100 shadow-xl">
                        <figure><img src={project10} alt="Solo Traveller" /></figure>
                        <div class="card-body">
                            <h2 class="card-title text-3xl font-bold">
                                Solo Traveller
                                <div class="badge badge-secondary">Full-Stack</div>
                            </h2>
                            <h2 className='text-2xl font-bold'> Features</h2>
                            <p> User can show different travel destination
                                user can choose destinations for their own
                                User can sign in and sign out
                                There are several authentication system including google and facebook sign in option
                                There is a checkout page to choose any tour plan.</p>
                            <h2 className='text-2xl font-bold'>Used Technology</h2>
                            <ol>
                                <li>React Bootstrap</li>
                                <li>React Router Dom</li>
                                <li>Environmente Variable</li>
                                <li>Firebase Authentication</li>
                            </ol>
                            <h2 className='text-2xl font-bold'>Other 3rd party Extensions</h2>
                            <ol>
                                <li>React Firebase hooks</li>
                                <li>Fontawesome icons</li>

                            </ol>
                            <div class="card-actions justify-end">
                                <a className='btn btn-primary' href="https://motor-parts-manufacturer.web.app/" target='_blank'>Live Site</a>
                                <a className='btn btn-primary' href="https://github.com/sajolbhadra/solo-traveller" target='_blank'>Client Git Repo</a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    );
};

export default SoloTraveller;